import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { propComparator } from '@fi-shared/utils/array-sort-comparators';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { StatisticService } from '@fi-shared/statistic/statistic.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ModuleType } from '@fi-shared/types/module-type';
import { RoleModel } from '../role.model';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { RoleService } from '../services/role.service';
import { FiItemsDeleteHelperService } from '@fi-shared/fi-shared-services/fi-items-delete-helper.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { ApplicationSettingsModel } from '@fi-app/role/application-settings.model';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { AppTextService } from '@fi-shared/app-text';
import { MoreMenuMobileSettingsModel } from '@fi-app/utilities/more-menu-mobile/more-menu-mobile-settings.model';
import { RoleHelperService } from '../services/role-helper.service';
import { CustomButtonModel } from '@fi-app/core/custom-button.model';

@Component({
    selector: 'fi-role-view',
    templateUrl: './role-view.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./role-view.component.scss'],
    host: { class: 'fi-role-view' },
    standalone: false,
})
export class RoleViewComponent implements OnInit {
    @Input('role') Role: RoleModel;
    HasEditAccess: boolean = false;
    roleCustomButtons: CustomButtonModel[];
    roleApplicationSettingGroups: {
        [key: string]: ApplicationSettingsModel[];
    };

    EditTabs: EditTabsModel;
    MoreMenuItems: MoreMenuMobileSettingsModel;

    constructor(
        private stateAccessCheckService: StateAccessCheckService,
        private statisticService: StatisticService,
        private stateService: FiStateService,
        private roleService: RoleService,
        private roleHelperService: RoleHelperService,
        private itemsDeleteHelperService: FiItemsDeleteHelperService,
        private detectDevicesService: DetectDevicesService,
        private appTextService: AppTextService,
    ) {}

    ngOnInit() {
        this.HasEditAccess = this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.Role.Edit);
        this.roleCustomButtons = this.Role.CustomButtons.sort(propComparator('SortIndex'));

        this.roleApplicationSettingGroups = this.roleHelperService.getRoleApplicationSettingGroups(
            this.Role.RoleApplicationSettings,
        );
        this.EditTabs = new EditTabsModel(this.Role.Name, this.appTextService.get('back'));
        this.initMoreMenuMobile();

        this.statisticService.Visit(ModuleType.Core, ObjectTypes.Role, this.Role.Id);
    }

    initMoreMenuMobile() {
        this.MoreMenuItems = new MoreMenuMobileSettingsModel();

        if (this.HasEditAccess) {
            this.MoreMenuItems.AddListItem(this.appTextService.get('common.edit'), () => this.editRole());

            this.MoreMenuItems.AddListItem(this.appTextService.get('common.delete'), () => this.deleteRole());
        }
    }

    isMobilePhone(): boolean {
        return this.detectDevicesService.isMobilePhone();
    }

    editRole() {
        this.stateService.go(FiStateNames.Role.Edit, { Id: this.Role.Id });
    }

    deleteRole() {
        this.itemsDeleteHelperService.commonDeleteConfirm(ObjectTypes.Role, [this.Role]).then(() => {
            this.roleService.deleteRoles([this.Role.Id]).then(() => {
                this.itemsDeleteHelperService.showDeletedObjectSimpleSnackBar(
                    ObjectTypes.Role,
                    [this.Role.Id],
                    this.Role.Name,
                );
                window.history.back();
            });
        });
    }
}
